import {
  DefaultFlightItineraryFragment,
  DefaultFlightSeatFragment,
  DefaultFlightTravelerSelectionFragment,
} from '../../../../graphql/generated/graphql';
/**
 * The seat a traveller holds on a segment, read off the trip rather than off any client-held pick.
 *
 * `travelerSelections` is the one place a seat is recorded once it is chosen, whether the pick came from the
 * manual basket, the agent picker or the airline: reading a second, client-supplied list alongside it meant two
 * sources could disagree about what the traveller had.
 */
export function getFlightSeatFromSegmentId(
  segmentId: string | undefined,
  travelerSelections: DefaultFlightTravelerSelectionFragment[] | undefined,
): DefaultFlightSeatFragment | undefined {
  if (!segmentId) {
    return undefined;
  }

  return travelerSelections?.[0]?.seats.find((selection) => selection.segmentId === segmentId)?.seat;
}

/**
 * Collect all selected seats from all segments
 */
export function getSeatFromItinerary(
  itinerary: DefaultFlightItineraryFragment,
  travelerSelections: DefaultFlightTravelerSelectionFragment[] | undefined,
): DefaultFlightSeatFragment[] {
  return itinerary.segments
    .map((segment) => getFlightSeatFromSegmentId(segment.id, travelerSelections))
    .filter((seat): seat is NonNullable<typeof seat> => seat !== undefined);
}
